<vdr-page-block>
    <vdr-action-bar class="custom-action-bar">
        <vdr-ab-right class="action-bar-item">
            <vdr-action-bar-items locationId="popup-list"></vdr-action-bar-items>
            <a class="btn btn-primary" id="createbtn" [routerLink]="['./create']">
                <clr-icon shape="plus"></clr-icon>
                Create One
            </a>
            <button class="btn btn-secondary ml-2" (click)="openBulkTimeSlotModal()">
                <clr-icon shape="plus"></clr-icon>
                Create Bulk
            </button>
        </vdr-ab-right>
    </vdr-action-bar>
</vdr-page-block>
<vdr-dt2-search
    [searchTermControl]="searchTermControl"
    [searchTermPlaceholder]="'common.search-by-name' | translate"
></vdr-dt2-search>

<vdr-data-table-2
    id="time-slot-list"
    [items]="items$ | async"
    [itemsPerPage]="itemsPerPage$ | async"
    [totalItems]="totalItems$ | async"
    [currentPage]="currentPage$ | async"
    [filters]="filters"
    (pageChange)="setPageNumber($event)"
    (itemsPerPageChange)="setItemsPerPage($event)"
>
    <vdr-bulk-action-menu
        locationId="time-slot-list"
        [hostComponent]="this"
        [selectionManager]="selectionManager"
    />

    <vdr-dt2-column id="id" [heading]="'common.id' | translate" [hiddenByDefault]="true">
        <ng-template let-timeSlot="item">{{ timeSlot.id }}</ng-template>
    </vdr-dt2-column>
    <vdr-dt2-column id="date" heading="date">
        <ng-template let-timeSlot="item">
            <a class="button-ghost" [routerLink]="['./', timeSlot.id]">
                {{ fromUtcDateOnly(timeSlot.date) }}
                <clr-icon shape="arrow right"></clr-icon>
            </a>
        </ng-template>
    </vdr-dt2-column>
    <vdr-dt2-column
        id="created-at"
        [heading]="'common.created-at' | translate"
        [sort]="sorts.get('createdAt')"
    >
        <ng-template let-timeSlot="item">{{ timeSlot.createdAt | localeDate: 'short' }}</ng-template>
    </vdr-dt2-column>
    <vdr-dt2-column
        id="updated-at"
        [heading]="'common.updated-at' | translate"
        [hiddenByDefault]="true"
        [sort]="sorts.get('updatedAt')"
    >
        <ng-template let-timeSlot="item">{{ timeSlot.updatedAt | localeDate: 'short' }}</ng-template>
    </vdr-dt2-column>
</vdr-data-table-2>
